import { useEffect, useState } from "react"
import { useLocale, useT } from "react-polyglot-hooks"
import flatten from "lodash/flatten"
import styled from "styled-components"
import LazyLoad from "react-lazyload"
import DefaultLayout from "components/layouts/DefaultLayout"
import Typography from "components/styled/Typography"
import { Container } from "components/styled/Grid"
import Faq from "components/structuredData/Faq"
import Link from "components/Link"
import { sendEvent } from "scripts/GoogleAnalytics"
import Canonical from "components/Canonical"

import WhiteButton from "components/styled/Buttons/WhiteButton"
import { emptyCarsFilter } from "redux/actions"
import { useDispatch } from "react-redux"
import Block from "./Block"

const CtaContainer = styled.div`
  position: relative;
`

const CtaContent = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`



const StyledWhiteButton = styled(WhiteButton)`
  color: ${({ theme }) => theme.colors.skyBlue};
`

export default function FaqScene() {
  const t = useT()
  const locale = useLocale()
  const dispatch = useDispatch()
  const [list, setList] = useState([])
  const backgroundUrl = `${process.env.NEXT_PUBLIC_CLOUDINARY}w_auto,f_auto,q_auto/static/faq`

  useEffect(() => {
    import(`../../../i18n/${locale}/faq_list.json`).then(res => setList(res.default))
  }, [])
  const allQuestions = flatten(list.map(x => x.list))

  const handleClick = () => {
    dispatch(emptyCarsFilter())
    sendEvent("Click CTA search car", { event_category: "faq", event_label: "Search car footer" })
  }

  return (
    <DefaultLayout page="faq">
      <Canonical page="faq" />
      <Faq list={allQuestions} />
      <Container top={50} bottom={75}>
        <Typography variant="title1" weight="bold" center space style={{ marginBottom: "50px" }}>
          {t("faq.title")}
        </Typography>
        {list.map((item, i) => (
          <Block key={item.id} item={item} last={list.length === i + 1} />
        ))}
      </Container>
      <CtaContainer>
        <LazyLoad height={200}>
          <picture>
            <source
              srcSet={`${backgroundUrl}/faq_bg-375px,
                ${backgroundUrl}/faq_bg-375px_2x 2x,
                ${backgroundUrl}/faq_bg-375px_3x 3x`}
              media="(max-width: 576px)"
            />
            <source
              srcSet={`${backgroundUrl}/faq_bg-768px,
                ${backgroundUrl}/faq_bg-768px_2x 2x,
                ${backgroundUrl}/faq_bg-768px_3x 3x`}
              media="(max-width: 768px)"
            />
            <source
              srcSet={`${backgroundUrl}/faq_bg-1024px,
                ${backgroundUrl}/faq_bg-1024px_2x 2x,
                ${backgroundUrl}/faq_bg-1024px_3x 3x`}
              media="(max-width: 1024px)"
            />
            <source
              srcSet={`${backgroundUrl}/faq_bg-1440px,
                ${backgroundUrl}/faq_bg-1440px_2x 2x,
                ${backgroundUrl}/faq_bg-1440px_3x 3x`}
            />
            <img alt="faq_bg" src={`${backgroundUrl}/faq_bg-768px`} style={{ width: "100%" }} />
          </picture>
        </LazyLoad>
        <CtaContent>
          <Typography variant="title2" weight="medium" color="white" space center>
            {t("faq.cta")}
          </Typography>
          <Link page="stock">
            <StyledWhiteButton as="a" size="xl" onClick={handleClick} style={{ marginTop: "25px" }}>
              {t("common.view_all_offers")}
            </StyledWhiteButton>
          </Link>
        </CtaContent>
      </CtaContainer>
    </DefaultLayout>
  )
}
